module.exports = __webpack_public_path__ + "static/img/Round-08-2016.47652e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-08-2016.jpg
// module id = Xtic
// module chunks = 0